import React, { useState } from 'react';
import '../styles/Portfolio.scss';
import DoublePage from '../Components/DoublePage.js';
import { pipe } from '../utils.js';
import { Nav } from "./Portfolio/Nav.js";

const Portfolio = ({ clients }) => {
    const [selected, setSelected] = useState(clients[0]);
    const [loaded, setLoaded] = useState(false)
    
    const onLoad = pipe(
        () => setLoaded(true),
        () => document.querySelector('#portfolio .major').scrollTo(0, 0)
    );

    const clickHandler = moveCursor => name => e => {
        e.preventDefault();
        moveCursor(e);
        setLoaded(false);
        setSelected(name);
    };
    
    return (
        <DoublePage
            id="portfolio"
            minor={
                <Nav
                    clickHandler={clickHandler}
                    items={clients}
                    selected={selected}
                    setSelected={setSelected}
                    setLoaded={setLoaded}
                />
            }
            major={
                <img
                    id="project"
                    className={loaded ? 'appear' : 'hide'}
                    src={`portfolio/${selected}.svg`}
                    alt={selected} onLoad={onLoad}
                />
            }
        />
    )
}

export default Portfolio;